export default "__VITE_ASSET__DCwvOWkG__"